// Generated from @cascade/api-contracts. Do not edit.
// Run: pnpm --filter @cascade/api-client build

import type {
  TApiRequestOptions,
  TApiTransport,
} from '#request/request.types.ts';
import type {
  TGetActiveUsersByDeviceRequestPayload,
  TGetActiveUsersByDeviceResponsePayload,
  TGetActiveUsersByTimeRequestPayload,
  TGetActiveUsersByTimeResponsePayload,
  TGetConversationsEscalatedByTimeRequestPayload,
  TGetConversationsEscalatedByTimeResponsePayload,
  TGetGeBacktrackRatesPerStepRequestPayload,
  TGetGeBacktrackRatesPerStepResponsePayload,
  TGetGeMessagesByTimeRequestPayload,
  TGetGeMessagesByTimeResponsePayload,
  TGetGeRecommendationAcceptanceRatePerStepRequestPayload,
  TGetGeRecommendationAcceptanceRatePerStepResponsePayload,
  TGetGeRecommendationAcceptanceRateRequestPayload,
  TGetGeRecommendationAcceptanceRateResponsePayload,
  TGetGeTotalUsersByDeviceRequestPayload,
  TGetGeTotalUsersByDeviceResponsePayload,
  TGetGeTypeBacktrackRatesPerStepRequestPayload,
  TGetGeTypeBacktrackRatesPerStepResponsePayload,
  TGetGeTypeMessagesByTimeRequestPayload,
  TGetGeTypeMessagesByTimeResponsePayload,
  TGetGeTypeRecommendationAcceptanceRateRequestPayload,
  TGetGeTypeRecommendationAcceptanceRateResponsePayload,
  TGetGeTypeUsersByDeviceRequestPayload,
  TGetGeTypeUsersByDeviceResponsePayload,
  TGetGeTypeUsersByTimeRequestPayload,
  TGetGeTypeUsersByTimeResponsePayload,
  TGetGeTypeUsersPerStepRequestPayload,
  TGetGeTypeUsersPerStepResponsePayload,
  TGetGeUsersByDeviceRequestPayload,
  TGetGeUsersByDeviceResponsePayload,
  TGetGeUsersByTimeRequestPayload,
  TGetGeUsersByTimeResponsePayload,
  TGetGeUsersPerStepRequestPayload,
  TGetGeUsersPerStepResponsePayload,
  TGetMessagesBySourceRequestPayload,
  TGetMessagesBySourceResponsePayload,
  TGetMessagesByTimeRequestPayload,
  TGetMessagesByTimeResponsePayload,
  TGetProjectTopicsRequestPayload,
  TGetProjectTopicsResponsePayload,
  TGetTopicMessagesRequestPayload,
  TGetTopicMessagesResponsePayload,
  TGetTopicSeriesRequestPayload,
  TGetTopicSeriesResponsePayload,
  TGetTotalGeMessagesByTimeRequestPayload,
  TGetTotalGeMessagesByTimeResponsePayload,
  TGetTotalGeRecommendationAcceptanceRateRequestPayload,
  TGetTotalGeRecommendationAcceptanceRateResponsePayload,
  TGetTotalGeUsersByTimeRequestPayload,
  TGetTotalGeUsersByTimeResponsePayload,
} from './metrics.types.ts';

export const createMetricsApi = (transport: TApiTransport) => ({
  /** Metric: active users by device */
  getActiveUsersByDevice: (
    payload: TGetActiveUsersByDeviceRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetActiveUsersByDeviceRequestPayload,
      TGetActiveUsersByDeviceResponsePayload
    >('/get_active_users_by_device', payload, options),

  /** Metric: active users over time */
  getActiveUsersByTime: (
    payload: TGetActiveUsersByTimeRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetActiveUsersByTimeRequestPayload,
      TGetActiveUsersByTimeResponsePayload
    >('/get_active_users_by_time', payload, options),

  /** Metric: escalated conversations over time */
  getConversationsEscalatedByTime: (
    payload: TGetConversationsEscalatedByTimeRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetConversationsEscalatedByTimeRequestPayload,
      TGetConversationsEscalatedByTimeResponsePayload
    >('/get_conversations_escalated_by_time', payload, options),

  /** Metric: guided-experience backtrack rates per step */
  getGeBacktrackRatesPerStep: (
    payload: TGetGeBacktrackRatesPerStepRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetGeBacktrackRatesPerStepRequestPayload,
      TGetGeBacktrackRatesPerStepResponsePayload
    >('/get_ge_backtrack_rates_per_step', payload, options),

  /** Metric: guided-experience messages over time */
  getGeMessagesByTime: (
    payload: TGetGeMessagesByTimeRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetGeMessagesByTimeRequestPayload,
      TGetGeMessagesByTimeResponsePayload
    >('/get_ge_messages_by_time', payload, options),

  /** Metric: guided-experience recommendation acceptance rate */
  getGeRecommendationAcceptanceRate: (
    payload: TGetGeRecommendationAcceptanceRateRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetGeRecommendationAcceptanceRateRequestPayload,
      TGetGeRecommendationAcceptanceRateResponsePayload
    >('/get_ge_recommendation_acceptance_rate', payload, options),

  /** Metric: recommendation acceptance rate per step */
  getGeRecommendationAcceptanceRatePerStep: (
    payload: TGetGeRecommendationAcceptanceRatePerStepRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetGeRecommendationAcceptanceRatePerStepRequestPayload,
      TGetGeRecommendationAcceptanceRatePerStepResponsePayload
    >('/get_ge_recommendation_acceptance_rate_per_step', payload, options),

  /** Metric: guided-experience users by device */
  getGeTotalUsersByDevice: (
    payload: TGetGeTotalUsersByDeviceRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetGeTotalUsersByDeviceRequestPayload,
      TGetGeTotalUsersByDeviceResponsePayload
    >('/get_ge_total_users_by_device', payload, options),

  /** Metric: backtrack rates per step by experience type */
  getGeTypeBacktrackRatesPerStep: (
    payload: TGetGeTypeBacktrackRatesPerStepRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetGeTypeBacktrackRatesPerStepRequestPayload,
      TGetGeTypeBacktrackRatesPerStepResponsePayload
    >('/get_ge_type_backtrack_rates_per_step', payload, options),

  /** Metric: messages over time by experience type */
  getGeTypeMessagesByTime: (
    payload: TGetGeTypeMessagesByTimeRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetGeTypeMessagesByTimeRequestPayload,
      TGetGeTypeMessagesByTimeResponsePayload
    >('/get_ge_type_messages_by_time', payload, options),

  /** Metric: recommendation acceptance rate by experience type */
  getGeTypeRecommendationAcceptanceRate: (
    payload: TGetGeTypeRecommendationAcceptanceRateRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetGeTypeRecommendationAcceptanceRateRequestPayload,
      TGetGeTypeRecommendationAcceptanceRateResponsePayload
    >('/get_ge_type_recommendation_acceptance_rate', payload, options),

  /** Metric: users by device by experience type */
  getGeTypeUsersByDevice: (
    payload: TGetGeTypeUsersByDeviceRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetGeTypeUsersByDeviceRequestPayload,
      TGetGeTypeUsersByDeviceResponsePayload
    >('/get_ge_type_users_by_device', payload, options),

  /** Metric: users over time by experience type */
  getGeTypeUsersByTime: (
    payload: TGetGeTypeUsersByTimeRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetGeTypeUsersByTimeRequestPayload,
      TGetGeTypeUsersByTimeResponsePayload
    >('/get_ge_type_users_by_time', payload, options),

  /** Metric: users per step by experience type */
  getGeTypeUsersPerStep: (
    payload: TGetGeTypeUsersPerStepRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetGeTypeUsersPerStepRequestPayload,
      TGetGeTypeUsersPerStepResponsePayload
    >('/get_ge_type_users_per_step', payload, options),

  /** Metric: guided-experience users by device */
  getGeUsersByDevice: (
    payload: TGetGeUsersByDeviceRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetGeUsersByDeviceRequestPayload,
      TGetGeUsersByDeviceResponsePayload
    >('/get_ge_users_by_device', payload, options),

  /** Metric: guided-experience users over time */
  getGeUsersByTime: (
    payload: TGetGeUsersByTimeRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetGeUsersByTimeRequestPayload,
      TGetGeUsersByTimeResponsePayload
    >('/get_ge_users_by_time', payload, options),

  /** Metric: guided-experience users per step */
  getGeUsersPerStep: (
    payload: TGetGeUsersPerStepRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetGeUsersPerStepRequestPayload,
      TGetGeUsersPerStepResponsePayload
    >('/get_ge_users_per_step', payload, options),

  /** Metric: messages by source */
  getMessagesBySource: (
    payload: TGetMessagesBySourceRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetMessagesBySourceRequestPayload,
      TGetMessagesBySourceResponsePayload
    >('/get_messages_by_source', payload, options),

  /** Metric: messages over time */
  getMessagesByTime: (
    payload: TGetMessagesByTimeRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetMessagesByTimeRequestPayload,
      TGetMessagesByTimeResponsePayload
    >('/get_messages_by_time', payload, options),

  /** Lists the project's topics */
  getProjectTopics: (
    payload: TGetProjectTopicsRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetProjectTopicsRequestPayload,
      TGetProjectTopicsResponsePayload
    >('/get_project_topics', payload, options),

  /** Lists a topic's messages */
  getTopicMessages: (
    payload: TGetTopicMessagesRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetTopicMessagesRequestPayload,
      TGetTopicMessagesResponsePayload
    >('/get_topic_messages', payload, options),

  /** Metric: topic activity over time */
  getTopicSeries: (
    payload: TGetTopicSeriesRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetTopicSeriesRequestPayload,
      TGetTopicSeriesResponsePayload
    >('/get_topic_series', payload, options),

  /** Metric: total guided-experience messages over time */
  getTotalGeMessagesByTime: (
    payload: TGetTotalGeMessagesByTimeRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetTotalGeMessagesByTimeRequestPayload,
      TGetTotalGeMessagesByTimeResponsePayload
    >('/get_total_ge_messages_by_time', payload, options),

  /** Metric: total recommendation acceptance rate */
  getTotalGeRecommendationAcceptanceRate: (
    payload: TGetTotalGeRecommendationAcceptanceRateRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetTotalGeRecommendationAcceptanceRateRequestPayload,
      TGetTotalGeRecommendationAcceptanceRateResponsePayload
    >('/get_total_ge_recommendation_acceptance_rate', payload, options),

  /** Metric: total guided-experience users over time */
  getTotalGeUsersByTime: (
    payload: TGetTotalGeUsersByTimeRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TGetTotalGeUsersByTimeRequestPayload,
      TGetTotalGeUsersByTimeResponsePayload
    >('/get_total_ge_users_by_time', payload, options),
});
